<template>
  <v-row>
    <v-col>
      <v-subheader class="white--text">Fatura Bilgileri</v-subheader>
      <v-list dense color="transparent">
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Ad Soyad </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoiceFullname }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Unvan </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoiceCompany }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> VD | VN / TC | Tip </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoiceTax }} | {{ callCenterStore.invoiceVat }} |
              {{ callCenterStore.invoiceType }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Telefon </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoicePhone }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> E-Posta </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoiceMail }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Adres </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.invoiceAddress }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
// Store
import { useCallCenterStore } from "@/stores/callCenter";

export default {
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
    };
  },
};
</script>

<style></style>
